import { getLocaleInfo } from './info';

export default function numberSymbols(locale) {
    var info = getLocaleInfo(locale);

    return info.numbers.symbols;
}
//# sourceMappingURL=number-symbols.js.map



//////////////////
// WEBPACK FOOTER
// c:/Projects/YuDRIV/ServicesAPI/YuDriv-ServicesAPI/Enforcement/~/@telerik/kendo-intl/dist/es/cldr/number-symbols.js
// module id = ../../../../@telerik/kendo-intl/dist/es/cldr/number-symbols.js
// module chunks = 3